/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ share: NonNullable<unknown> }} Statsundoshare2Inputs */

const en_statsundoshare2 = /** @type {(inputs: Statsundoshare2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.share} undone`)
};

const de_statsundoshare2 = /** @type {(inputs: Statsundoshare2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.share} zurückgenommen`)
};

/**
* | output |
* | --- |
* | "{share} undone" |
*
* @param {Statsundoshare2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsundoshare2 = /** @type {((inputs: Statsundoshare2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsundoshare2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsundoshare2(inputs)
	return de_statsundoshare2(inputs)
});
export { statsundoshare2 as "statsUndoShare" }